import EditIcon from 'assets/ver2/icons/edit-profile-icon.svg';
import SizeBox from 'components/common/SizeBox';
import { FUNC_DEFAULT } from 'constants';
import useLang from 'hooks/useLang';
import React, { useImperativeHandle, useState } from 'react';
import styled from 'styled-components';
import {
  cursorPointerMixin,
  displayBlockCenter,
  displayFlexColStartCenterMixin,
  displayGridCenterStartMixin,
  fontSize14Mixin,
  fontSize14MixinObject,
  paragraph500Mixin,
  paragraph600Mixin,
} from 'styles';

const FormEditItemExpandable = ({
  children = <></>,
  ref,
  label = '',
  value = '',
  note = '',
  onOpen = FUNC_DEFAULT,
  onUpdate = FUNC_DEFAULT,
  isDisabled = false,
  onShowConfirmCancelFormEditModal = FUNC_DEFAULT,
}) => {
  const { t } = useLang();

  const [isExpand, setExpand] = useState(false);

  useImperativeHandle(
    ref,
    () => ({
      isExpand,
      setExpand,
    }),
    [isExpand, setExpand]
  );

  const handleOnOpenExpand = () => {
    if (isDisabled) return;
    onOpen();
    setExpand(true);
  };
  const handleOnCloseExpand = () => {
    onShowConfirmCancelFormEditModal();
  };
  const handleOnClickEditIcon = () => {
    handleOnOpenExpand();
  };

  const handleOnClickUpdateButton = () => {
    const isUpdateSuccessful = onUpdate();
    if (isUpdateSuccessful) {
      setExpand(false);
    }
  };
  const renderEditCancelButton = () => {
    if (!isExpand)
      return (
        <EditIconStyled
          src={EditIcon}
          onClick={handleOnClickEditIcon}
        ></EditIconStyled>
      );
    return (
      <CancelButton onClick={handleOnCloseExpand}>
        {t('button_cancel')}
      </CancelButton>
    );
  };

  const renderChildren = () => {
    if (!isExpand)
      return (
        <ChildrenStyled>
          <SizeBox height={10} />
          <Text>{value}</Text>
        </ChildrenStyled>
      );
    return (
      <ChildrenStyled>
        <SizeBox height={16} />
        {children}
        <SizeBox height={16} />
        <UpdateButton onClick={handleOnClickUpdateButton}>
          {t('button_update')}
        </UpdateButton>
        <SizeBox height={16} />
        <NoteText>{note}</NoteText>
      </ChildrenStyled>
    );
  };

  return (
    <>
      <FormEditItemExpandableStyled
        $isExpand={isExpand}
        $isDisabled={isDisabled}
      >
        <Label>{label}</Label>
        {renderChildren()}
        {renderEditCancelButton()}
      </FormEditItemExpandableStyled>
    </>
  );
};

const FormEditItemExpandableStyled = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 10px;
  padding: 10px;
  position: relative;

  ${(props) =>
    props.$isExpand
      ? displayFlexColStartCenterMixin
      : displayGridCenterStartMixin};
  ${(props) =>
    props.$isExpand ? `padding-right: 10px;` : `padding-right: 50px;`};
  ${(props) =>
    props.$isDisabled ? `background: transparent;` : `background: #ffffff;`};

  & p {
    ${(props) =>
      props.$isDisabled &&
      `
        color: #7A8189;
      `}
  }

  & img {
    ${(props) =>
      props.$isDisabled &&
      `
      filter: invert(54%) sepia(9%) saturate(371%) hue-rotate(172deg) brightness(91%) contrast(83%);
      `}
  }
`;

const Label = styled.p`
  ${paragraph600Mixin};
`;

const Text = styled.p`
  ${paragraph500Mixin};
  text-transform: uppercase;
`;

const NoteText = styled.p`
  ${paragraph500Mixin};
  ${fontSize14MixinObject};
`;

const CancelButton = styled.span`
  position: absolute;
  right: 20px;
  top: 10px;
  ${cursorPointerMixin};
  ${paragraph500Mixin};
  ${fontSize14Mixin};
  color: #97241d;
`;
const UpdateButton = styled.span`
  ${cursorPointerMixin};
  ${paragraph500Mixin};
  ${fontSize14Mixin};
  color: #002ff1;
  text-decoration: underline;
  ${displayBlockCenter};
  text-align: center;
`;
const EditIconStyled = styled.img`
  position: absolute;
  right: 20px;
  top: 10px;
  ${cursorPointerMixin};
`;

const ChildrenStyled = styled.div`
  width: 100%;
  height: fit-content;
`;

export default FormEditItemExpandable;
